import React from 'react';
import { Box } from '@withjoy/joykit';
import type { WebsitePhotoAlignment, WebsitePhotoBaseProperties } from '@shared/types/WebsiteHeaderSettings.types';
import { OptimizedEventGuestSitePhoto } from '@apps/guest/packages/layout-engine/components/OptimizedEventGuestSitePhoto';
import globalWindow from '@shared/core/globals';

export const Photo: React.FC<Partial<WebsitePhotoBaseProperties> & { alignment?: WebsitePhotoAlignment; showPlaceholder?: boolean }> = props => {
  const { url, alignment, showPlaceholder } = props;

  if (!url && showPlaceholder) {
    return <Box style={{ height: '100vh', backgroundColor: 'lightgray' }} />;
  }

  if (!url) {
    return null;
  }

  // Aloha center uses alignment-based positioning for uncropped photos.
  // Override the default 'center' backgroundPosition with the editor-selected focal point.
  const backgroundPosition = alignment ? `${alignment.alignX} ${alignment.alignY}` : undefined;

  return (
    <Box style={{ height: '100vh' }}>
      <OptimizedEventGuestSitePhoto
        photoUrl={url}
        width={globalWindow.innerWidth ?? 0}
        height={globalWindow.innerHeight ?? 0}
        containerType="viewport"
        containerAspectRatio={(globalWindow.innerWidth ?? 1) / (globalWindow.innerHeight ?? 1)}
        backgroundPosition={backgroundPosition}
      />
    </Box>
  );
};
